import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { Star, Sparkles, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { API } from '../utils/helpers';
import MarkdownRenderer from './MarkdownRenderer';

const BirthdayBanner = () => {
  const { refreshUser } = useAuth();
  const [birthdayData, setBirthdayData] = useState(null);
  const [reading, setReading] = useState(null);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    fetch(`${API}/user/birthday-check`, { credentials: 'include' })
      .then(res => res.json())
      .then(setBirthdayData)
      .catch(() => {});
  }, []);

  const generateReading = async () => {
    setGenerating(true);
    try {
      const res = await fetch(`${API}/birthday-reading`, {
        method: 'POST',
        credentials: 'include'
      });
      if (res.ok) {
        const data = await res.json();
        setReading(data);
        toast.success('Lectura de cumpleanos generada');
      } else {
        const err = await res.json();
        toast.error(err.detail);
      }
    } catch (e) { toast.error('Error al generar lectura'); }
    setGenerating(false);
  };

  if (!birthdayData?.is_birthday) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
      className="glass-card p-6 mb-8 border-2 border-yellow-500/40 relative overflow-hidden"
      data-testid="birthday-banner"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 via-purple-500/5 to-pink-500/5" />
      <div className="relative">
        <h2 className="text-xl font-bold gold-text mb-2 flex items-center gap-2">
          <Sparkles className="w-5 h-5" /> Feliz Cumpleanos
        </h2>
        
        {!reading ? (
          <div>
            <p className="text-[var(--text-secondary)] mb-4">
              Las estrellas celebran contigo hoy. Tienes una lectura de tarot especial de cumpleanos esperandote.
            </p>
            {birthdayData.reading_available ? (
              <button 
                onClick={generateReading}
                disabled={generating}
                className="btn-gold"
                data-testid="birthday-reading-btn"
              >
                {generating ? <Loader2 className="w-4 h-4 animate-spin inline mr-2" /> : <Star className="w-4 h-4 inline mr-2" />}
                {generating ? 'Consultando las estrellas...' : 'Recibir mi Lectura de Cumpleanos'}
              </button>
            ) : (
              <p className="text-purple-400 text-sm">Ya recibiste tu lectura de cumpleanos este ano.</p>
            )}
          </div>
        ) : (
          <div className="mt-4">
            <p className="text-sm text-purple-400 mb-4">Tu signo: {reading.sign_es}</p>
            <div className="flex justify-center gap-3 flex-wrap mb-6">
              {reading.cards.map((card, i) => (
                <div key={i} className="text-center">
                  <div className={`w-20 aspect-[2/3] rounded-lg overflow-hidden border border-yellow-500/30 shadow-lg shadow-yellow-500/10 ${card.reversed ? 'rotate-180' : ''}`}>
                    <img src={card.image} alt={card.name} className="w-full h-full object-cover" />
                  </div>
                  <p className="text-yellow-300 text-xs font-medium mt-1">{card.position}</p>
                  <p className="text-[var(--text-muted)] text-xs">{card.name}</p>
                </div>
              ))}
            </div>
            <MarkdownRenderer content={reading.interpretation} className="text-[var(--text-secondary)] text-sm" data-testid="birthday-reading-text" />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default BirthdayBanner;
